var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageIntroLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 131.772,
    height: 53.102,
    viewBox: "0 0 131.772 53.102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1118",
    "data-name": "\\uC0AC\\uAC01\\uD615 1118",
    width: 131.772,
    height: 53.102,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2821",
    "data-name": "\\uADF8\\uB8F9 2821",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1913",
    "data-name": "\\uD328\\uC2A4 1913",
    d: "M41.724,27.12H36.962L29.973,43.712h4.76Z",
    transform: "translate(-3.089 -2.795)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1914",
    "data-name": "\\uD328\\uC2A4 1914",
    d: "M43.945,29.813l-2.382,5.652,3.591,8.524h4.757Z",
    transform: "translate(-4.284 -3.073)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1915",
    "data-name": "\\uD328\\uC2A4 1915",
    d: "M100.587,27.12H95.826L88.839,43.712H93.6Z",
    transform: "translate(-9.156 -2.795)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1916",
    "data-name": "\\uD328\\uC2A4 1916",
    d: "M102.808,29.813l-2.38,5.652,3.591,8.524h4.757Z",
    transform: "translate(-10.351 -3.073)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2820",
    "data-name": "\\uADF8\\uB8F9 2820",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2819",
    "data-name": "\\uADF8\\uB8F9 2819",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1917",
    "data-name": "\\uD328\\uC2A4 1917",
    d: "M4.243,38.694v.1a.916.916,0,0,0,.174.5,1.7,1.7,0,0,0,.521.489,3.214,3.214,0,0,0,.893.372,4.912,4.912,0,0,0,1.284.148A3.1,3.1,0,0,0,8.8,39.977a.893.893,0,0,0,.468-.69,1.083,1.083,0,0,0-.677-.912,13.084,13.084,0,0,0-2.217-.893c-.682-.21-1.388-.464-2.122-.753a9.8,9.8,0,0,1-2.01-1.071,5.668,5.668,0,0,1-1.514-1.55,3.905,3.905,0,0,1-.6-2.187,4.6,4.6,0,0,1,.487-2.134,4.8,4.8,0,0,1,1.371-1.613,6.514,6.514,0,0,1,2.1-1.029,9.374,9.374,0,0,1,2.677-.361,9.794,9.794,0,0,1,2.752.371,6.691,6.691,0,0,1,2.2,1.072,5.2,5.2,0,0,1,1.458,1.688,4.577,4.577,0,0,1,.532,2.216v.235H9.463v-.15A1.341,1.341,0,0,0,9.3,31.6a1.735,1.735,0,0,0-.49-.571A2.67,2.67,0,0,0,8,30.616a3.7,3.7,0,0,0-1.142-.16,2.749,2.749,0,0,0-1.588.352.972.972,0,0,0-.479.775c0,.325.215.6.641.827a15.923,15.923,0,0,0,2.164.849q.873.3,1.98.731A10.214,10.214,0,0,1,11.649,35.1a6.312,6.312,0,0,1,1.632,1.634,4.012,4.012,0,0,1,.664,2.324,4.306,4.306,0,0,1-.511,2.133,4.485,4.485,0,0,1-1.414,1.54,6.847,6.847,0,0,1-2.131.935,10.785,10.785,0,0,1-2.689.318,11.255,11.255,0,0,1-2.839-.342,7.352,7.352,0,0,1-2.284-.986,4.864,4.864,0,0,1-1.522-1.6A4.228,4.228,0,0,1,0,38.885v-.191Z",
    transform: "translate(0 -2.76)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1918",
    "data-name": "\\uD328\\uC2A4 1918",
    d: "M16.378,27.14H31.3v4.118H26.015V43.7H21.664V31.258H16.378Z",
    transform: "translate(-1.688 -2.797)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1919",
    "data-name": "\\uD328\\uC2A4 1919",
    d: "M51.9,43.7V27.14h3.7L63.173,36.4V27.14H67.5V43.7H63.825l-7.57-9.233V43.7Z",
    transform: "translate(-5.35 -2.797)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1920",
    "data-name": "\\uD328\\uC2A4 1920",
    d: "M72.041,27.14h7.876a8.734,8.734,0,0,1,3.492.657,7.065,7.065,0,0,1,2.512,1.794,7.735,7.735,0,0,1,1.513,2.643,10.252,10.252,0,0,1,0,6.389,7.624,7.624,0,0,1-1.513,2.632,7.13,7.13,0,0,1-2.512,1.783,8.7,8.7,0,0,1-3.492.659H72.041Zm4.35,4.118V39.6h3.2a4.436,4.436,0,0,0,1.719-.309,3.366,3.366,0,0,0,1.24-.859,3.615,3.615,0,0,0,.752-1.316,5.489,5.489,0,0,0,.248-1.7,4.428,4.428,0,0,0-1-3.014,3.716,3.716,0,0,0-2.959-1.146Z",
    transform: "translate(-7.425 -2.797)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1921",
    "data-name": "\\uD328\\uC2A4 1921",
    d: "M119.057,27.139a7.585,7.585,0,0,1,2.828.479,5.418,5.418,0,0,1,1.979,1.305,5.249,5.249,0,0,1,1.164,1.93,7.093,7.093,0,0,1,.383,2.335,6.959,6.959,0,0,1-.207,1.7,5.959,5.959,0,0,1-.621,1.539,5.53,5.53,0,0,1-1.045,1.3,5.474,5.474,0,0,1-1.477.966l3.674,5.009h-5.2l-3.218-4.437H115.1V43.7h-4.329V27.139ZM115.1,31v4.416h3.72a3.03,3.03,0,0,0,1.109-.181,2,2,0,0,0,.741-.476,1.848,1.848,0,0,0,.413-.7,2.708,2.708,0,0,0,.13-.829,2.375,2.375,0,0,0-.544-1.592A2.328,2.328,0,0,0,118.818,31Z",
    transform: "translate(-11.417 -2.797)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1922",
    "data-name": "\\uD328\\uC2A4 1922",
    d: "M129.181,27.14h7.878a8.733,8.733,0,0,1,3.491.657,7.033,7.033,0,0,1,2.512,1.794,7.677,7.677,0,0,1,1.513,2.643,10.235,10.235,0,0,1,0,6.389,7.567,7.567,0,0,1-1.513,2.632,7.1,7.1,0,0,1-2.512,1.783,8.7,8.7,0,0,1-3.491.659h-7.878Zm4.353,4.118V39.6h3.2a4.441,4.441,0,0,0,1.718-.309,3.4,3.4,0,0,0,1.24-.859,3.589,3.589,0,0,0,.752-1.316,5.462,5.462,0,0,0,.249-1.7,4.42,4.42,0,0,0-1-3.014,3.718,3.718,0,0,0-2.958-1.146Z",
    transform: "translate(-13.314 -2.797)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1923",
    "data-name": "\\uD328\\uC2A4 1923",
    d: "M24.879,52.573V51.76h-2.8v-.779h3.713v1.486c0,2.8-1.092,4.673-3.765,5.323v-.837c1.962-.545,2.852-2.08,2.852-4.381m3.381,5.648h-.932V50.85h.932Z",
    transform: "translate(-2.27 -5.241)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1924",
    "data-name": "\\uD328\\uC2A4 1924",
    d: "M31.1,55.347v-.764h6.975v.764H35.141v1.364h-.925V55.347Zm6.47-3.65H35.038v.057c0,.8,1.406,1.381,2.61,1.446v.739a4.784,4.784,0,0,1-3.064-1.17,4.747,4.747,0,0,1-3.081,1.17V53.2c1.212-.056,2.612-.649,2.612-1.446V51.7h-2.5V50.95h5.957Zm-5.035,4.421V57.5h5.173v.764H31.614V56.118Z",
    transform: "translate(-3.206 -5.251)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1925",
    "data-name": "\\uD328\\uC2A4 1925",
    d: "M40.47,53.742h6.975v.732H40.47Zm.367-1.722a.842.842,0,0,1,.377-.723,5.341,5.341,0,0,1,2.756-.456,5.268,5.268,0,0,1,2.75.456.877.877,0,0,1,0,1.438,5.28,5.28,0,0,1-2.75.455,5.352,5.352,0,0,1-2.756-.455.839.839,0,0,1-.377-.715M41.9,57.041v.536h5.207v.716H40.983V56.335H46.01v-.545H40.983v-.714H46.94v1.966Zm-.135-5.022a.305.305,0,0,0,.152.243,5.476,5.476,0,0,0,2.049.212,5.47,5.47,0,0,0,2.049-.212.3.3,0,0,0,.152-.243.282.282,0,0,0-.152-.245,5.287,5.287,0,0,0-2.049-.218,5.293,5.293,0,0,0-2.049.218.287.287,0,0,0-.152.245",
    transform: "translate(-4.171 -5.24)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1926",
    "data-name": "\\uD328\\uC2A4 1926",
    d: "M53.016,52.924a2.162,2.162,0,0,1,.631-1.666,1.989,1.989,0,0,1,1.392-.463,1.958,1.958,0,0,1,1.373.463,1.706,1.706,0,0,1,.317.381h1.715v-.8h.931V56h-.931V54.176h-1.69a1.77,1.77,0,0,1-.342.431,2.041,2.041,0,0,1-1.373.454,2.074,2.074,0,0,1-1.392-.454,2.189,2.189,0,0,1-.631-1.683m6.5,5.323H53.587v-2.5h.93v1.739h4.994Zm-5.592-5.323a1.494,1.494,0,0,0,.369,1.105,1.047,1.047,0,0,0,.752.268,1.074,1.074,0,0,0,.749-.268,1.9,1.9,0,0,0,0-2.2,1.074,1.074,0,0,0-.749-.268,1.047,1.047,0,0,0-.752.268,1.486,1.486,0,0,0-.369,1.1M57,52.405a3.35,3.35,0,0,1,.043.519,2.965,2.965,0,0,1-.035.5h1.434V52.405Z",
    transform: "translate(-5.464 -5.235)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1927",
    "data-name": "\\uD328\\uC2A4 1927",
    d: "M62.269,56.012v-.78h6.872v.78H66.154v2.341h-.924V56.012ZM67.81,52.7v-.974H62.619V50.95H68.74V52.6a9.722,9.722,0,0,1-.18,1.99h-.921A8.99,8.99,0,0,0,67.81,52.7",
    transform: "translate(-6.418 -5.251)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1928",
    "data-name": "\\uD328\\uC2A4 1928",
    d: "M73.248,51.671V50.614h.93v1.057h1.749v.764H71.514v-.764Zm-1.417,3.754a2.481,2.481,0,0,1,.8-2.1A1.94,1.94,0,0,1,73.752,53a1.809,1.809,0,0,1,1.008.26,3.029,3.029,0,0,1,.026,4.307,1.888,1.888,0,0,1-1.034.268,1.868,1.868,0,0,1-1.092-.309,2.4,2.4,0,0,1-.829-2.106m.921,0a1.931,1.931,0,0,0,.41,1.455.884.884,0,0,0,.59.2.828.828,0,0,0,.554-.195,1.883,1.883,0,0,0,.444-1.464,1.846,1.846,0,0,0-.478-1.5.963.963,0,0,0-1.092.032,1.9,1.9,0,0,0-.428,1.47m5.131-4.6v3.007H79.1V54.6H77.883V58.2h-.931V50.826Z",
    transform: "translate(-7.371 -5.216)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1929",
    "data-name": "\\uD328\\uC2A4 1929",
    d: "M80.95,54.455h6.975v.764H80.95ZM82.384,50.9v1.8h5.079v.763h-6V50.9Zm0,5.007v1.584h5.174v.764H81.463V55.911Z",
    transform: "translate(-8.343 -5.246)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1930",
    "data-name": "\\uD328\\uC2A4 1930",
    d: "M95.483,55.888a3.568,3.568,0,0,1-2.235,1.837v-.813c.93-.406,1.766-1.154,1.766-3.21V50.94h.925V53.7c0,2.056.852,2.8,1.773,3.21v.813a3.613,3.613,0,0,1-2.229-1.837m4.14-5.038v3.007h1.214v.771H99.623v3.593h-.929V50.85Z",
    transform: "translate(-9.611 -5.241)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1931",
    "data-name": "\\uD328\\uC2A4 1931",
    d: "M106.338,54.954h-3.473V52.565h2.841v-.886h-2.841V50.94h3.765V53.3h-2.836v.918h2.783a2.594,2.594,0,0,0,1.512-.325V50.85h.929v1.739h1.127v.78h-1.127v1.869h-.929v-.65a2.929,2.929,0,0,1-1.752.366m-3.03.739h5.71v2.6h-5.71Zm4.782.756H104.23v1.1h3.859Z",
    transform: "translate(-10.602 -5.241)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1932",
    "data-name": "\\uD328\\uC2A4 1932",
    d: "M112.062,53.753h6.974v.732h-6.974Zm6.47-2.072H113.5v.772h5.079v.732h-6V50.95h5.957ZM113.5,57.053v.536H118.7V58.3h-6.128V56.346H117.6V55.8h-5.027v-.714h5.957v1.966Z",
    transform: "translate(-11.55 -5.251)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1933",
    "data-name": "\\uD328\\uC2A4 1933",
    d: "M129.474,8.706a5.35,5.35,0,0,0,.861-2.925A5.58,5.58,0,0,0,124.762.207h-8.837v13.44H120.2V4.28h4.563a1.5,1.5,0,0,1,1.5,1.5,1.613,1.613,0,0,1-1.5,1.623h-2.949v3.833h3.882a2.044,2.044,0,0,1,1.934,2.058,1.926,1.926,0,0,1-1.934,1.923H70.871L63.446,0,54.313,18.368l-2.564-3.157H4.924V.247H.594V19.308h49.22l5.33,6.535L63.412,9.216,68.328,19.29h57.366a6,6,0,0,0,6.006-6,5.8,5.8,0,0,0-2.226-4.59",
    transform: "translate(-0.061 0)",
    fill: "#1a1311"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIntroLogo);
export default __webpack_public_path__ + "static/media/image-introLogo.df2bfb79f440086993425242732589b7.svg";
export { ForwardRef as ReactComponent };